/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useContext, useEffect, useState } from 'react'
import { toast } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

//import BackButton from '../../Components/Buttons/BackButton'
import PrimaryButton from '../../Components/Buttons/PrimaryButton'
import SecondaryButton from '../../Components/Buttons/SecondaryButton'
import FormInput from '../../Components/FormInput/FormInput'
import FormPlacesNearByInput from '../../Components/FormInput/FormPlacesNearByInput'
import Header from '../../Components/Header/Header'
import MultiSelect from '../../Components/MultiSelect/MultiSelect';
import { authContext } from '../../store/AuthContext';

const AddSite = () => {

    const serverURL = process.env.REACT_APP_SERVER_URL;
    const token = JSON.parse(localStorage.getItem('token'));
    const history = useHistory();

    const authCtx = useContext(authContext);

    if (authCtx.adminType !== 'super' && authCtx.adminType !== 'data') {
        history.push('/form');
    }

    const defaultState = {
        title: '',
        name: '',
        address: '',
        hira: '',
        description: '',
        price: '',
        overviewTitle: '',
        overviewDescription: '',
        propertyType: '',
        unitSize: '',
        numberOfUnits: '',
        numberOfTower: '',
        numberOfFloors: '',
        landArea: '',
        possessionYear: '',
        possessionStatus: '',
        whyToChoose: '',
        whyToChooseTitle: '',
        locationTitle: '',
        locationDescription: '',
        mapUrl: '',
        placesNearBy: [{}],
        floorPlanTitle: '',
        floorPlanDescription: '',
        amenitiesTitle: '',
        amenitiesDescription: '',
        amenities: '',
        brochure: null,
        headerScript: '',
        bodyScript: '',
        footerScript: '',
        thankYouScript: '',
        galleryTitle: '',
        galleryDescription: ''
    }

    const [property, setProperty] = useState(defaultState);
    const [amenities, setAmenities] = useState([]);

    const getAmenities = async () => {

        const res = await toast.promise(
            axios({
                method: "GET",
                url: `${serverURL}/api/amenities`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }), {
            loading: "Fetching...",
            success: "Data fetched successfully",
            error: "Couldn't fetch the data"
        }
        )

        const { data } = res.data;
        setAmenities(data)
    }

    const textInputChangeHandler = (event) => {
        setProperty((prevState) => {
            return {
                ...prevState,
                [event.target.name]: event.target.value
            }
        })
    }

    const editorInputChangeHandler = (data) => {
        setProperty((prevState) => {
            return {
                ...prevState,
                [data.name]: data.value
            }
        })
    }

    const PlacesNearbyHandler = (data) => {
        setProperty((prevState) => {
            return {
                ...prevState,
                placesNearBy: data
            }
        })
    }

    const brochureChangeHandler = (e) => {
        const brochure = e.target.files[0];

        if (brochure) {
            setProperty((prevState) => {
                return {
                    ...prevState,
                    brochure
                }
            })
        }
    }

    const removeBrochureHandler = () => {
        setProperty((prevState) => {
            return {
                ...prevState,
                brochure: null
            }
        })
        document.getElementById('brochure-input').value = "";
    }

    const createPropertyHandler = async (event) => {
        event.preventDefault();

        let data = { ...property };

        data.placesNearBy = JSON.stringify(data.placesNearBy);

        const res = await toast.promise(
            axios({
                method: 'POST',
                url: `${serverURL}/api/sites`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                data: {
                    ...data,
                    brochure: undefined
                }
            }), {
            loading: "Creating...",
            success: "Data created successfully",
            error: "Couldn't create the data"
        }
        )

        if (!res || !res.status !== 200) {
            history.push('/sites');
        }

        if (property.brochure !== null) {

            const newFormData = new FormData();

            newFormData.append('property', res.data.data._id);
            newFormData.append('brochure', property.brochure);

            await axios({
                method: "POST",
                url: `${serverURL}/api/brochure`,
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                },
                data: newFormData
            })
        }
        history.push('/sites');
    }

    const amenityChangeHandler = (selectedAmenities) => {
        const ids = []
        selectedAmenities.forEach((item) => ids.push(item._id))
        setProperty((prevState) => {
            return {
                ...prevState,
                amenities: JSON.stringify(ids)
            }
        })
    }

    useEffect(() => {
        getAmenities();
    }, [])

    return (
        <Fragment>
            <Header />
            <div className='container' >
                {/* {<BackButton to='/sites' >Back to Sites</BackButton>} */}
                <h3 className='heading-primary mt-20' >Add Site</h3>
                <hr />
                <div className="main">
                    <div className="form pd-2">
                        <form className='row'>
                            <div className='col-lg-4'>
                                <FormInput onChange={textInputChangeHandler} value={property.name} autoComplete='off' type='text' label='Site Name' id='name' />
                            </div>
                            <div className='col-lg-4'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Property Type' id='propertyType' />
                            </div>
                            <div className='col-lg-4'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Address' id='address' />
                            </div>
                            <div className='col-lg-12'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='RERA' id='hira' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Title' id='title' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Overview Title' id='overviewTitle' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={editorInputChangeHandler} autoComplete='off' type='editor' label='Description' id='description' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={editorInputChangeHandler} autoComplete='off' type='editor' label='Overview Description' id='overviewDescription' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Price' id='price' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Unit Size' id='unitSize' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Number of Units' id='numberOfUnits' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Number of Towers' id='numberOfTower' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Number of Floors' id='numberOfFloors' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Land Area' id='landArea' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Possession Year' id='possessionYear' />
                            </div>
                            <div className='col-lg-3'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Possession Status' id='possessionStatus' />
                            </div>
                            <div className='col-lg-12'>
                                <FormInput onChange={textInputChangeHandler} value={property.whyToChooseTitle} autoComplete='off' type='text' label='Why To Choose Title' id='whyToChooseTitle' />
                            </div>
                            <div className='col-lg-12'>
                                <FormInput onChange={editorInputChangeHandler} autoComplete='off' type='editor' label='Why To Choose' id='whyToChoose' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Location Title' id='locationTitle' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Location Description' id='locationDescription' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.galleryTitle} autoComplete='off' type='text' label='Gallery Title' id='galleryTitle' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} value={property.galleryDescription} autoComplete='off' type='text' label='Gallery Description' id='galleryDescription' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Floor Plan Title' id='floorPlanTitle' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Floor Plan Description' id='floorPlanDescription' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Amenities Title' id='amenitiesTitle' />
                            </div>
                            <div className='col-lg-6'>
                                <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Amenities Description' id='amenitiesDescription' />
                            </div>
                            <div className='col-lg-12'>
                                <div className='form-group'>
                                    <label>Select Amenities</label>
                                    <MultiSelect amenities={amenities} onChange={amenityChangeHandler} />
                                </div>
                            </div>
                            <div className='col-lg-12'>
                                <div className='form-group'>
                                    <FormInput onChange={textInputChangeHandler} autoComplete='off' type='text' label='Map Url' id='mapUrl' />
                                </div>
                            </div>
                            <div style={{ margin: '15px' }} >
                                <label>Brochure</label>
                                <input style={{ marginRight: '15px' }} id='brochure-input' onChange={brochureChangeHandler} type='file' accept='application/pdf' />
                                <PrimaryButton type='button' onClick={removeBrochureHandler} >Remove</PrimaryButton>
                            </div>
                            <div style={{ backgroundColor: '#f7f7f7', padding: '1rem 0', width: '100%', margin: '1rem 15px' }} >
                                <div className='col-lg-12'>
                                    <FormPlacesNearByInput onChange={PlacesNearbyHandler} />
                                </div>
                            </div>
                            <div className='col-lg-12'>
                                <div className="form-group">
                                    <label className='d-block' >Header Script</label>
                                    <textarea className='form-control shadow-none' style={{ width: '100%', minHeight: '140px' }} onChange={textInputChangeHandler} name="headerScript" value={property.headerScript}  ></textarea>
                                </div>
                            </div>
                            <div className='col-lg-12'>
                                <div className="form-group">
                                    <label className='d-block' >Body Script</label>
                                    <div >
                                        <textarea className='form-control shadow-none' style={{ width: '100%', minHeight: "140px" }} onChange={textInputChangeHandler} name="bodyScript" value={property.bodyScript}  ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-12'>
                                <div className="form-group">
                                    <label className='d-block' >Footer Script</label>
                                    <textarea className='form-control shadow-none' style={{ width: '100%', minHeight: "140px" }} onChange={textInputChangeHandler} name="footerScript" value={property.footerScript}  ></textarea>
                                </div>
                            </div>
                            <div className='col-lg-12'>
                                <div className="form-group">
                                    <label className='d-block' >Thank You Page Script</label>
                                    <textarea className='form-control shadow-none' style={{ width: '100%', minHeight: "140px" }} onChange={textInputChangeHandler} name="thankYouScript" value={property.thankYouScript}  ></textarea>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <hr />
                <div className='add-site-actions' >
                    <SecondaryButton style={{ width: '20%' }} type='button' onClick={createPropertyHandler} >Submit</SecondaryButton>
                    <PrimaryButton style={{ width: '20%' }} onClick={() => {
                        history.push('/sites')
                    }} type='button' >Cancel</PrimaryButton>
                </div>
                <br /><br />
            </div>
        </Fragment>
    )
}

export default AddSite